import { defaultPalette } from "./default";

export const lightPalette = {
  ...defaultPalette,
  HeaderBackground: defaultPalette.White,
  HeaderBorder: defaultPalette.Basic300,
  HeaderText: defaultPalette.Basic800,
  HeaderTextSecondary: defaultPalette.Basic600,
  MenuText: defaultPalette.Basic900,
  MenuTextSelected: defaultPalette.Basic200,
  MenuItemSelectedBg: defaultPalette.Black,
  UserText: defaultPalette.Basic900,
  UserTextSecondary: defaultPalette.Basic800,
};
  